import { Card, Descriptions, Table, Tag } from "antd";
import { get } from "lodash";
import PricingInput from "../Components/PricingInput";
import PricingSummary from "../Components/PricingSummary";

const ReviewSummary = ({ values, setFieldValue, data }) => {
  const pricingMode = get(values, "pricingMode");
  const coverages = get(values, "insurancePlanCoverages", []);

  return (
    <div className="configure-step">
      <Card title="Récapitulatif du plan" className="m-bottom-16">
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Nom">
            {get(values, "name")}
          </Descriptions.Item>
          <Descriptions.Item label="Identifiant">
            {get(values, "identifier")}
          </Descriptions.Item>
          <Descriptions.Item label="Risque">
            <Tag>{get(values, "risk")}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Statut">
            <Tag
              color={get(values, "status") === "ACTIVE" ? "green" : "default"}
            >
              {get(values, "status")}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Mode de tarification">
            <Tag color={pricingMode === "COMPOSABLE" ? "green" : "blue"}>
              {pricingMode === "COMPOSABLE" ? "Composable" : "Forfaitaire"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Garanties">
            <Tag color="blue">{coverages.length}</Tag>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {pricingMode === "PACKAGED" && (
        <Card title="Prix du plan" className="m-bottom-16">
          <p style={{ color: "#8A92A5", marginBottom: 16 }}>
            Définir le prix forfaitaire de ce plan d'assurance
          </p>
          <PricingInput
            value={get(data, "pricer.prices")}
            onChange={() => {}}
            label="Prix mensuel du plan"
          />
          <p style={{ color: "#8A92A5", marginTop: 8, fontSize: 12 }}>
            Note : Le tarificateur du plan est configuré séparément dans l'écran de gestion des tarificateurs
          </p>
        </Card>
      )}

      {pricingMode === "COMPOSABLE" && (
        <PricingSummary coverages={coverages} />
      )}

      <Card title="Détail des garanties" className="m-bottom-16">
        {coverages.map((coverage) => {
          const category = get(coverage, "coverageCategory", {});
          const mappings = get(coverage, "coverageMappings", []);

          return (
            <Card
              key={coverage.id}
              size="small"
              className="m-bottom-8"
              title={
                <div
                  className="d-flex"
                  style={{ gap: "8px", alignItems: "center" }}
                >
                  {category.icon && (
                    <img
                      src={category.icon}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                  )}
                  {category.label || category.value}
                  <Tag>{get(coverage, "pricingMode") === "COMPOSABLE" ? "Composable" : "Forfaitaire"}</Tag>
                </div>
              }
            >
              <Table
                dataSource={mappings}
                rowKey="id"
                size="small"
                pagination={false}
                columns={[
                  {
                    title: "Prestation",
                    dataIndex: ["coverage", "type"],
                    render: (type, record) => (
                      <span>
                        {type}
                        {get(record, "coverage.subtype") &&
                          ` - ${get(record, "coverage.subtype")}`}
                      </span>
                    ),
                  },
                  {
                    title: "Remb.",
                    width: 120,
                    render: (_, record) => {
                      const brss = get(record, "brssPercentage");
                      const pmss = get(record, "pmssPercentage");
                      const flat = get(record, "reimbursementAmount");
                      if (brss) return `${brss}% BRSS`;
                      if (pmss) return `${pmss}% PMSS`;
                      if (flat) return `${flat} €`;
                      return "-";
                    },
                  },
                  {
                    title: "Carence",
                    dataIndex: "carenceDays",
                    width: 80,
                    render: (days) => days ? `${days} j` : "-",
                  },
                  {
                    title: "Franchise",
                    dataIndex: "franchiseAmount",
                    width: 80,
                    render: (amount) => amount ? `${amount} €` : "-",
                  },
                  {
                    title: "Limites",
                    dataIndex: "limits",
                    width: 80,
                    render: (limits) => (
                      <span>
                        {(limits || []).length > 0
                          ? `${limits.length} limite(s)`
                          : "-"}
                      </span>
                    ),
                  },
                  {
                    title: "Prix",
                    width: 160,
                    render: (_, record) => {
                      const covMode = get(coverage, "pricingMode");
                      const pricer = covMode === "PACKAGED"
                        ? get(coverage, "pricer")
                        : get(record, "pricer");
                      const prices = get(pricer, "prices");
                      if (!prices) return <Tag>-</Tag>;

                      const pType = get(prices, "type", "flat");
                      const unit = get(prices, "unit", "eur");
                      const suffix = unit === "pmss" ? "% PMSS" : "€";

                      if (pType === "flat") {
                        const monthly = get(prices, "monthly");
                        if (!monthly) return <Tag>-</Tag>;
                        return covMode === "PACKAGED"
                          ? <Tag color="blue">{monthly} {suffix}/mois (forfait)</Tag>
                          : <Tag color="green">{monthly} {suffix}/mois</Tag>;
                      }

                      const base = get(prices, "base", {});
                      const values = Object.values(base).filter((v) => v && v > 0);
                      if (values.length === 0) return <Tag>-</Tag>;

                      const min = Math.min(...values);
                      const max = Math.max(...values);
                      const range = min === max ? `${min}` : `${min} - ${max}`;
                      return covMode === "PACKAGED"
                        ? <Tag color="blue">{range} {suffix}/mois (forfait)</Tag>
                        : <Tag color="green">{range} {suffix}/mois</Tag>;
                    },
                  },
                ]}
              />
            </Card>
          );
        })}
      </Card>
    </div>
  );
};

export default ReviewSummary;
